import { call, put, takeLatest } from 'redux-saga/effects';
import {
  createChangeOrder,
  createChangeOrderSOV,
  deleteChangeOrder,
  deleteChangeOrderSOV,
  getChangeOrderDetail,
  getChangeOrderList,
  updateChangeOrder,
  updateChangeOrderSOV,
} from '../../api/constlink';
import {
  createChangeOrderAsync,
  createChangeOrderSOVAsync,
  CREATE_CHANGE_ORDER,
  CREATE_CHANGE_ORDER_SOV,
  deleteChangeOrderAsync,
  deleteChangeOrderSOVAsync,
  DELETE_CHANGE_ORDER,
  DELETE_CHANGE_ORDER_SOV,
  getChangeOrderDetailAsync,
  getChangeOrderListAsync,
  GET_CHANGE_ORDER_DETAIL,
  GET_CHANGE_ORDER_LIST,
  updateChangeOrderAsync,
  updateChangeOrderSOVAsync,
  UPDATE_CHANGE_ORDER,
  UPDATE_CHANGE_ORDER_SOV,
} from './actions';
import { ChangeOrder, ChangeOrderSOV } from './types';

function* getChangeOrderListSaga(
  action: ReturnType<typeof getChangeOrderListAsync.request>,
) {
  try {
    const changeOrders: ChangeOrder[] = yield call(
      getChangeOrderList,
      action.payload,
    );
    yield put(getChangeOrderListAsync.success(changeOrders));
  } catch (e: any) {
    yield put(getChangeOrderListAsync.failure(e));
  }
}

function* createChangeOrderSaga(
  action: ReturnType<typeof createChangeOrderAsync.request>,
) {
  try {
    const changeOrder: ChangeOrder = yield call(
      createChangeOrder,
      action.payload,
    );
    yield put(createChangeOrderAsync.success(changeOrder));
  } catch (e: any) {
    yield put(createChangeOrderAsync.failure(e));
  }
}

function* updateChangeOrderSaga(
  action: ReturnType<typeof updateChangeOrderAsync.request>,
) {
  try {
    const changeOrder: ChangeOrder = yield call(
      updateChangeOrder,
      action.payload,
    );
    yield put(updateChangeOrderAsync.success(changeOrder));
  } catch (e: any) {
    yield put(updateChangeOrderAsync.failure(e));
  }
}

function* deleteChangeOrderSaga(
  action: ReturnType<typeof deleteChangeOrderAsync.request>,
) {
  try {
    const changeOrderId: number = yield call(deleteChangeOrder, action.payload);
    yield put(deleteChangeOrderAsync.success(changeOrderId));
  } catch (e: any) {
    yield put(deleteChangeOrderAsync.failure(e));
  }
}

function* getChangeOrderDetailSaga(
  action: ReturnType<typeof getChangeOrderDetailAsync.request>,
) {
  try {
    const contract: ChangeOrder = yield call(
      getChangeOrderDetail,
      action.payload,
    );
    yield put(getChangeOrderDetailAsync.success(contract));
  } catch (e: any) {
    yield put(getChangeOrderDetailAsync.failure(e));
  }
}

function* createChangeOrderSOVSaga(
  action: ReturnType<typeof createChangeOrderSOVAsync.request>,
) {
  try {
    const contractSOV: ChangeOrderSOV = yield call(
      createChangeOrderSOV,
      action.payload,
    );
    yield put(createChangeOrderSOVAsync.success(contractSOV));
  } catch (e: any) {
    yield put(createChangeOrderSOVAsync.failure(e));
  }
}

function* updateChangeOrderSOVSaga(
  action: ReturnType<typeof updateChangeOrderSOVAsync.request>,
) {
  try {
    const contractSOV: ChangeOrderSOV = yield call(
      updateChangeOrderSOV,
      action.payload,
    );
    yield put(updateChangeOrderSOVAsync.success(contractSOV));
  } catch (e: any) {
    yield put(updateChangeOrderSOVAsync.failure(e));
  }
}

function* deleteChangeOrderSOVSaga(
  action: ReturnType<typeof deleteChangeOrderSOVAsync.request>,
) {
  try {
    const sovId: number = yield call(deleteChangeOrderSOV, action.payload);
    yield put(deleteChangeOrderSOVAsync.success(sovId));
  } catch (e: any) {
    yield put(deleteChangeOrderSOVAsync.failure(e));
  }
}

export function* changeOrdersSaga() {
  yield takeLatest(GET_CHANGE_ORDER_LIST, getChangeOrderListSaga);
  yield takeLatest(CREATE_CHANGE_ORDER, createChangeOrderSaga);
  yield takeLatest(UPDATE_CHANGE_ORDER, updateChangeOrderSaga);
  yield takeLatest(DELETE_CHANGE_ORDER, deleteChangeOrderSaga);
  yield takeLatest(GET_CHANGE_ORDER_DETAIL, getChangeOrderDetailSaga);
  yield takeLatest(CREATE_CHANGE_ORDER_SOV, createChangeOrderSOVSaga);
  yield takeLatest(UPDATE_CHANGE_ORDER_SOV, updateChangeOrderSOVSaga);
  yield takeLatest(DELETE_CHANGE_ORDER_SOV, deleteChangeOrderSOVSaga);
}
